
















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import AboutCarat from '@spa/components/organisms/mypage/user-info/carat/AboutCarat.vue'
import Carat from '@spa/components/organisms/mypage/user-info/carat/Carat.vue'

@Component({
  components: {
    AboutCarat,
    Carat,
  },
})
export default class UserInfoMobile extends Vue {
  @Prop({ required: true })
  carat: string
}
